import React from 'react';
import { FaCreditCard } from "react-icons/fa";
import { MdOutlineTimer } from "react-icons/md";
import { IoStorefront } from "react-icons/io5";
import { SiBuymeacoffee } from "react-icons/si";
import { IoHome } from "react-icons/io5";
import './BottomNav.css';

const BottomNav = ({ currentPage, setCurrentPage }) => {
  const navItems = [
    { id: 'home', label: 'Home', icon: <IoHome /> },
    { id: 'order', label: 'Pedidos', icon: <SiBuymeacoffee />  },
    { id: 'store', label: 'Tiendas', icon: <IoStorefront />},
    { id: 'cards', label: 'Tarjetas', icon: <FaCreditCard /> },/*'🏠''📝''🏪' '💳''⏰'*/
    { id: 'time', label: 'Tiempo', icon: <MdOutlineTimer /> } 
  ];

  return (
    <nav className="bottom-nav">
      {navItems.map(item => (
        <button
          key={item.id}
          className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
          onClick={() => setCurrentPage(item.id)}
        >
          <span className="nav-icon">{item.icon}</span>
          <span className="nav-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNav;